import { FunctionComponent } from 'react';
import { Environment } from '../util/Environment';

type Props = {
	title?: string;
};

export const ScreenTitle: FunctionComponent<Props> = (props) => {
	return <title>
		{props.title
			? `${Environment.gameName} - ${props.title}`
			: Environment.gameName}
	</title>;
};